import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { QueryPreservingNavigate } from 'src/components/layout/QueryPreservingNavigate'
import { NoAccessCard } from 'src/components/shared/NoAccessCard'
import { useInternalPermissions } from 'src/hooks/useInternalPermissions'
import type { PermissionGated } from 'src/interfaces/internalAccess'
import { resolveFirstAccessiblePath } from 'src/utils/internalAccess/resolveFirstAccessiblePath'

interface Props {
  // Module-level rail config (stable reference).
  items: Array<PermissionGated & { to: string }>
}

/** An app's index route: go to the first rail item the user may open. */
const FirstPermittedRedirectComponent = ({ items }: Props) => {
  const permissions = useInternalPermissions()

  const path = useMemo(() => {
    return resolveFirstAccessiblePath(items, permissions)
  }, [items, permissions])

  if (path === null) {
    return (
      <div css={tw`flex min-w-0 flex-1 flex-col p-6`} data-testid="first-permitted-redirect-empty">
        <NoAccessCard />
      </div>
    )
  }

  return <QueryPreservingNavigate to={path} />
}

export const FirstPermittedRedirect = memo(FirstPermittedRedirectComponent)
